import { UserSettings } from '@models/user-settings';
import { createReducer, on } from '@ngrx/store';
import * as UserSettingsActions from '@states/user-settings/user-settings.actions';
import { initialUserSettings } from '@consts/user-settings.const';
import { updateDevicePageViewSuccess } from '@states/user-settings/user-settings.actions';

export interface UserSettingsState {
  userSettings: UserSettings;
  isValid: boolean;
  g2Url: string;
}

export const initialState: UserSettingsState = {
  userSettings: initialUserSettings,
  isValid: false,
  g2Url: null,
};

export const userSettingsStateReducer = createReducer(
  initialState,
  on(UserSettingsActions.resetToInitialState, (state) => {
    return {
      ...initialState,
    };
  }),
  on(UserSettingsActions.setUserSettings, (state, { userSettings }) => {
    return {
      ...state,
      userSettings: {
        ...initialUserSettings,
        ...userSettings,
      },
    };
  }),
  on(UserSettingsActions.setUserSettingProperty, (state, { prop, value }) => {
    return {
      ...state,
      userSettings: {
        ...state.userSettings,
        [prop]: value,
      },
    };
  }),
  on(UserSettingsActions.setValidateStatus, (state, { isValid }) => {
    return {
      ...state,
      isValid,
    };
  }),
  on(UserSettingsActions.updateUserThemeSuccess, (state, { settings }) => {
    return {
      ...state,
      userSettings: {
        ...state.userSettings,
        theme: settings.theme,
      },
    };
  }),
  on(UserSettingsActions.updateWeeklySubscriptionSuccess, (state, { settings }) => {
    return {
      ...state,
      userSettings: {
        ...state.userSettings,
        subForWeekly: settings.subForWeekly,
      },
    };
  }),
  on(UserSettingsActions.updateDevicePageViewSuccess, (state, { settings }) => {
    return {
      ...state,
      userSettings: {
        ...state.userSettings,
        newDevicePageView: settings.newDevicePageView,
      },
    };
  }),
  on(UserSettingsActions.getG2FeedbackSuccess, (state, { url }) => {
    return {
      ...state,
      g2Url: url,
    };
  }),
  on(UserSettingsActions.updateUserGlobalSearchSettingsSuccess, (state, { settings }) => {
    return {
      ...state,
      userSettings: {
        ...state.userSettings,
        ...settings,
      },
    };
  }),
);
